import React from "react";
import cx from "classnames";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithImageOnRight(props: ListItem.Props) {
  const { description, timestamp, image } = props;

  return (
    <article className={cx([styles.listItemContainer, styles.right])}>
      <div className={styles.mainColumn} data-skeleton-selector>
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
      <div className={styles.rightColumn} data-skeleton-selector>
        {image && <ListItem.Image {...props} />}
        {!image && timestamp && <ListItem.Timestamp {...props} />}
      </div>
    </article>
  );
}
WithImageOnRight.displayName = "WithImageOnRight.Component";

export { WithImageOnRight };

export * from "./Themed";
